export class GetUsersForYourOrganization {
  public static readonly type = "[Organization] Get Users For Your Organization";
  public constructor(public organizationId: string) {}
}
